import { SelectOptionsInterface } from '../../../../models/interfaces/documenti-adempimenti/carica-documento.interfaces';

const RICHIESTA_INVIO_SI_ID = 1;
const RICHIESTA_INVIO_NO_ID = 2;

/** Opzioni della select 'Richiesta nuovo invio'. */
export const RICHIESTA_INVIO_OPTIONS: SelectOptionsInterface[] = [
  { id: RICHIESTA_INVIO_SI_ID, desc: 'Sì' },
  { id: RICHIESTA_INVIO_NO_ID, desc: 'No' },
];

/** Converte l'id della select nel boolean della query. */
export function toRichiestaInvioParam(id: number | undefined): boolean | undefined {
  if (id === RICHIESTA_INVIO_SI_ID) {
    return true;
  }
  if (id === RICHIESTA_INVIO_NO_ID) {
    return false;
  }
  return undefined;
}

/** Converte il boolean dello store nell'id da ripristinare sulla select. */
export function toRichiestaInvioSelectId(value: boolean | null | undefined): number | undefined {
  if (value == null) {
    return undefined;
  }
  return value ? RICHIESTA_INVIO_SI_ID : RICHIESTA_INVIO_NO_ID;
}
